<template>
    <el-tabs v-model="innerValue" v-bind="$attrs" v-on="$listeners" class="tab-container">
        <template v-for="item in tabs">
            <el-tab-pane
                :key="item.value"
                :label="`${item.label}(${item.count || 0})`"
                :name="`${item.value}`"
            />
        </template>
    </el-tabs>
</template>

<script>
export default {
    name: 'TabCount',
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            innerValue: this.value
        };
    },
    watch: {
        innerValue(v) {
            this.$emit('input', v);
            this.$emit('change', v);
        },
        value(v) {
            this.innerValue = v;
        }
    }
};
</script>

<style lang="scss" scoped>
.tab-container {
    padding: 0 10px;
    /deep/ .el-tabs__header {
        margin: 0;
    }
}
</style>
